module.exports = __webpack_public_path__ + "promotion_homepage.png?b1d943d7d445cd3b7fca15de337c96a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion_homepage.png
// module id = 997
// module chunks = 2